import { useMemo } from "react";

/**
 * Renders a LIFT template's questions as a form. Long-text uses textarea,
 * rating_5 uses a 1-5 pill row with hover states.
 */
export function QuestionRenderer({ template, answers, onChange, disabled = false }) {
  const answerMap = useMemo(() => {
    const m = {};
    (answers || []).forEach((a) => {
      m[a.question_id] = a.value;
    });
    return m;
  }, [answers]);

  const setValue = (q, value) => {
    if (disabled) return;
    const next = (answers || []).filter((a) => a.question_id !== q.id);
    next.push({
      question_id: q.id,
      question_text: q.text,
      type: q.type,
      value,
    });
    onChange(next);
  };

  return (
    <div className="space-y-6">
      {template.map((q) => (
        <div key={q.id} data-testid={`q-${q.id}`}>
          <label className="block text-sm font-medium text-forest-900 mb-2">
            {q.text}
            {q.required && <span className="text-terracotta-500 ml-1">*</span>}
          </label>
          {q.type === "long_text" ? (
            <textarea
              className="patria-input w-full min-h-[110px]"
              value={answerMap[q.id] || ""}
              onChange={(e) => setValue(q, e.target.value)}
              disabled={disabled}
              data-testid={`qi-${q.id}`}
            />
          ) : (
            <RatingRow q={q} value={answerMap[q.id]} onSet={(v) => setValue(q, String(v))} disabled={disabled} />
          )}
        </div>
      ))}
    </div>
  );
}

function RatingRow({ q, value, onSet, disabled }) {
  const labels = q.labels || ["1", "2", "3", "4", "5"];
  const active = parseInt(value || "0", 10);
  return (
    <div className="flex flex-wrap gap-2" data-testid={`rating-${q.id}`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          type="button"
          disabled={disabled}
          key={n}
          onClick={() => onSet(n)}
          className={`px-3 py-2 rounded-full text-sm font-medium border transition-colors ${
            n === active
              ? "bg-forest-600 text-cream-100 border-forest-600"
              : "bg-cream-100 text-charcoal border-sage-300 hover:bg-sage-200"
          }`}
          data-testid={`rating-${q.id}-${n}`}
        >
          <span className="font-semibold">{n}</span>
          <span className="ml-2 text-xs opacity-80">{labels[n - 1] || ""}</span>
        </button>
      ))}
      {value && !disabled && (
        <button
          type="button"
          onClick={() => onSet("")}
          className="text-xs text-charcoal-muted underline ml-2"
        >
          clear
        </button>
      )}
    </div>
  );
}
